<template>
  <div :class="twMerge('relative overflow-x-auto rounded-lg border border-y-natural-light-grey delivery-table', tableClass)">
    <table class="w-full">

      <thead>
      <tr :class="twMerge('font-medium', props.appendHeader)">
        <th v-for="(header, index) in props.tableData.headers" :key="header.id"
            class="px-2 py-3 md:border-x border-x-natural-light-grey" :width="isMobile ? '' : '30%'">
          <p class="font-semibold">{{ header.text }}</p>
        </th>
      </tr>
      </thead>

      <tbody class="bg-[#fafafa]">
      <tr>
        <td class="py-3 px-2 border border-b-[#f5f6f7]">Monday</td>
        <td class="py-3 px-2 border border-b-[#f5f6f7]">Tuesday</td>
      </tr>
      <tr v-for="(row, rowIndex) in props.tableData.rows" :key="JSON.stringify(row)"
          :class="twMerge('border-t', props.appendRow)">

        <td v-for="(header, headerIndex) in props.tableData.headers" :key="headerIndex"
            class="py-3 px-2 border border-b-[#f5f6f7]">
            <TsTypography>{{ row[header.text] }}</TsTypography>
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge';
const {isMobile} = useDevice()

type Props = {
  title?: string;
  tableData?: {
    headers: object[];
    rows: Array<Record<string, any>>;
  };
  tableClass?: string;
  appendHeader?: string;
  appendRow?: string;
};

const props = withDefaults(defineProps<Props>(), {
  tableData: {
    headers: [{id: 1, text: "Orders placed before 10:00PM on:"}, {id: 2, text: "Expected Delivery Date:"}],
    rows: [
      {
        'Orders placed before 10:00PM on:': 'Tuesday',
        'Expected Delivery Date:': 'Wednesday',
      },
      {
        'Orders placed before 10:00PM on:': 'Tuesday',
        'Expected Delivery Date:': 'Wednesday',
      },
      {
        'Orders placed before 10:00PM on:': 'Tuesday',
        'Expected Delivery Date:': 'Wednesday',
      },
      {
        'Orders placed before 10:00PM on:': 'Tuesday',
        'Expected Delivery Date:': 'Wednesday',
      },
      {
        'Orders placed before 10:00PM on:': 'Tuesday',
        'Expected Delivery Date:': 'Wednesday',
      },
      {
        'Orders placed before 10:00PM on:': 'Tuesday',
        'Expected Delivery Date:': 'Wednesday',
      }
    ]
  },
});
</script>
